module.exports = __webpack_public_path__ + "media/images/icon__live@3x-aa899c0770c176756601a3eb128d13c1.png";